// extracted by mini-css-extract-plugin
export default {"root":"SectionTitle_root__rW6tl","description":"SectionTitle_description__RJqr7"};